import { render } from "./ChapterNext.vue?vue&type=template&id=24b7fe4c"
import script from "./ChapterNext.vue?vue&type=script&lang=js"
export * from "./ChapterNext.vue?vue&type=script&lang=js"
script.render = render

export default script